export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const HOME_PATH = '/v4'

export const PAGE_TITLES: any = {
  V3: 'StreamEast | Live HD Sports Streaming – NFL, NBA, F1, Boxing, UFC & More',
  WEBSITE_TITLE: 'StreamEast | Live HD Sports Streaming – NFL, NBA, F1, Boxing, UFC & More',
  SOCCER: 'Streameast - Latest High Quality HD Soccer Streams and Highlights',
  BOXING: 'Streameast - Boxing Streams live and upcoming matches',
  NFL: 'Streameast - Live NFL Streams and Upcoming NFL Fixtures',
  NBA: 'Streameast - NBA Streams and Fixtures',
  UFC: 'UFC Streams, UFC 315 and Upcoming UFC Events',
  MMA: 'Streameast - UFC Streams, UFC 315 and Upcoming UFC Events',
  TENNIS: 'Streameast - TENNIS Streams and Upcoming TENNIS Fixtures',
  RUGBY: 'Streameast - RUGBY Streams and Upcoming RUGBY Fixtures',
  MOTOGP: 'Streameast - MOTOGP Streams and Upcoming MOTOGP Fixtures',
  NHL: 'Streameast - NHL Streams and NHL Fixtures',
  MLB: 'Streameast - MLB Streams and Upcoming MLB Fixtures',
  F1: 'Streameast - F1 Live Streams and Fixtures',
  MLS: 'Streameast - MLS Streams and Fixtures',
  CRICKET: 'Streameast - Watch Live Cricket Matches and Checkout Match Schedules',
  TEAMS: 'Streameast - Checkout Upcoming Fixtures of popular Teams',
  LEAGUES: 'Streameast - Checkout Upcoming Fixtures of your Favorite Leagues',
  STANDINGS: 'Streameast - Points Table of Champions League, SERIE A, Leage 1, Laliga and Bundesliga',
  CONTACT: 'Streameast - Reach Out to Us',
  ABOUT: 'Streameast - Our Mission and Goals'
}

export const DIRECT_PLAYERS = [
  'SuperSports ENG HD',
  // 'rSoccerlink'
];

export const GREEN_PLAYER_SOURCES = [
  'Reddit-SoccerStreams', 
  'Reddit-Streams', 
  'ESPN 2 USA', 
  'TNT Sports 2 Uk', 
  'ESPN 2 USA', 
  'Full Hd Sports',
  'wow STREAM',
  'NBA TV',
  'NBA TV USA'
]
export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!'
}

export const CATEGORY_LINKS:any = {
  Soccer: '/Soccer',
  F1: '/streams/F1',
  UFC: '/streams/UFC',
  'BOXING|UFC': '/streams/Boxing',
  BOXING: '/streams/Boxing',
  TENNIS: '/streams/Tennis',
  NBA: '/streams/NBA',
  NFL: '/streams/NFL',
  RUGBY: '/streams/Rugby',
  CRICKET: '/streams/Cricket',
  MOTOGP: '/streams/Motogp'
};

export const categories = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'Tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'Motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  // {
  //   label: 'MLB',
  //   value: 'MLB'
  // },
  // {
  //   label: 'NHL',
  //   value: 'NHL'
  // },
  {
    label: 'Rugby',
    value: 'Rugby'
  }
  // {
  //   label: 'Cricket',
  //   value: 'cricket'
  // }
];

export const MENU_CATEGORIES = [
  // {
  //   label: 'Soccer',
  //   value: 'Soccer'
  // },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'Tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'Motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  // {
  //   label: 'MLB',
  //   value: 'MLB'
  // },
  // {
  //   label: 'NHL',
  //   value: 'NHL'
  // },
  {
    label: 'Rugby',
    value: 'Rugby'
  }
  // {
  //   label: 'Cricket',
  //   value: 'cricket'
  // }
];

export const NOT_SOCCER = ['tennis', 'cricket', 'f1', 'boxing|ufc', 'nfl', 'motogp','nba', 'nhl', 'mlb', 'rugby', 'wwe','ufc'];

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const DEFAULT_LEAGUE_LINK = '/leagues/Premier League/645bec5ba42012fa6eb37334';
export const DEFAULT_TEAM_LINK = '/teams/Liverpool/6455eab25477a7f3d047a4cc';
export const DEFAULT_IMAGE_PATH = 'https://res.cloudinary.com/djfixkqyj/image/upload/v1709307398/Images/Default-Sports-Logo_luku1o.webp'
